<template>
    <b-modal size="lg" id="snel_start_v2_manager_modal">
        <template slot="modal-title">Manage general SnelStart v2 config</template>
        <v-app class="v-appNoBackground v-app">
            <b-form ref="snel_start_v2_manager_modal_form">
                <b-form-group label="Shipping code number for SnelStart.">
                    <b-form-input
                            id="SnelStartShippingId"
                            placeholder="000"
                            :state="isNotNullAndUndefinedAndEmpty(SnelStartV2Config.ShippingCostCode)"
                            v-model="SnelStartV2Config.ShippingCostCode"
                            required/>
                </b-form-group>

                <hr/>
                <h3>Tax rate to SnelStart Shipping article number</h3>
                <hr/>

                <b-form-group>

                    <div class="row">
                        <p class="col-5">Shopware tax rate</p>
                        <p class="col-5">Snelstart Shipping article number</p>
                        <p class="col-1">Delete</p>
                    </div>
                    <div class="row"
                         v-for="(taxRate) in objectKeys(SnelStartV2Config.ShippingCostCodeForTax)"
                         :key="componentKey">
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input :value="taxRate" readonly/>
                            </b-form-group>
                        </div>
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input
                                        id="ShippingArticleNumber"
                                        placeholder="SW-shipping"
                                        :state="isNotNullAndUndefinedAndEmpty(SnelStartV2Config.ShippingCostCodeForTax[taxRate])"
                                        v-model="SnelStartV2Config.ShippingCostCodeForTax[taxRate]"
                                        @change="forceRerender()"
                                        required/>
                            </b-form-group>
                        </div>
                        <div class="col-1 lowProfileRow">
                            <v-btn icon
                                   @click="forceRerender(), delete SnelStartV2Config.ShippingCostCodeForTax[taxRate]">
                                <v-icon color="error">mdi-minus-circle</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <b-form-group label="Add new tax rate for mapping">
                        <div class="row">
                            <div class="col-10">
                                <b-form-input id="newTaxRateForShippingArticle"
                                              placeholder="21"
                                              class="form-control-sm"
                                              v-model="tempVars.newShippingTaxIdField"/>
                            </div>
                            <div class="col-2">
                                <v-btn icon
                                       @click='forceRerender(), SnelStartV2Config.ShippingCostCodeForTax[tempVars.newShippingTaxIdField] = "", tempVars.newShippingTaxIdField = ""'
                                       :disabled="!isNotNullAndUndefinedAndEmpty(tempVars.newShippingTaxIdField)">
                                    <v-icon color="success">mdi-plus-circle</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </b-form-group>
                </b-form-group>

                <hr/>
                <h3>product turnover group mapping</h3>
                <hr/>

                <b-form-group>

                    <div class="row">
                        <p class="col-5">Shopware product tax ID</p>
                        <p class="col-5">Snelstart artikelomzetgroep ID</p>
                        <p class="col-1">Delete</p>
                    </div>
                    <div class="row"
                         v-for="(taxId) in objectKeys(SnelStartV2Config.TurnoverGroupMapping)"
                         :key="componentKey">
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input :value="taxId" readonly/>
                            </b-form-group>
                        </div>
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input
                                        id="productTurnOverGroup"
                                        placeholder="ea830578-45c3-455f-a893-3f604c78af6f"
                                        :state="isNotNullAndUndefinedAndEmpty(SnelStartV2Config.TurnoverGroupMapping[taxId])"
                                        v-model="SnelStartV2Config.TurnoverGroupMapping[taxId]"
                                        @change="forceRerender()"
                                        required/>
                            </b-form-group>
                        </div>
                        <div class="col-1 lowProfileRow">
                            <v-btn icon
                                   @click="forceRerender(), delete SnelStartV2Config.TurnoverGroupMapping[taxId]">
                                <v-icon color="error">mdi-minus-circle</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <b-form-group label="Add new product turn over group mapping">
                        <div class="row">
                            <div class="col-10">
                                <b-form-input id="newTurnOverGroupForTaxId"
                                              placeholder="279ae5e9bc5b4f1daa79aac270ea4274"
                                              class="form-control-sm"
                                              v-model="tempVars.newTurnOverIdField"/>
                            </div>
                            <div class="col-2">
                                <v-btn icon
                                       @click='forceRerender(), SnelStartV2Config.TurnoverGroupMapping[tempVars.newTurnOverIdField] = "", tempVars.newTurnOverIdField = ""'
                                       :disabled="!isNotNullAndUndefinedAndEmpty(tempVars.newTurnOverIdField)">
                                    <v-icon color="success">mdi-plus-circle</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </b-form-group>
                </b-form-group>

                <hr/>
                <h3>credit term mapping</h3>
                <hr/>

                <b-form-group>
                    <b-form-group label="Fall back for credit term in days.">
                        <b-form-input
                                id="SnelStartCreditTermFallback"
                                placeholder="14"
                                :state="isNotNullAndUndefinedAndEmpty(SnelStartV2Config.creditTermMappingFallback)"
                                v-model="SnelStartV2Config.creditTermMappingFallback"
                                type="number"
                                required/>
                    </b-form-group>

                    <div class="row">
                        <p class="col-5">Shopware payment ID</p>
                        <p class="col-5">Days for credit</p>
                        <p class="col-1">Delete</p>
                    </div>
                    <div class="row"
                         v-for="(paymentId) in objectKeys(SnelStartV2Config.creditTermMapping)"
                         :key="componentKey">
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input :value="paymentId" readonly/>
                            </b-form-group>
                        </div>
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input
                                        id="creditTerm"
                                        placeholder="21"
                                        :state="isNotNullAndUndefinedAndEmpty(SnelStartV2Config.creditTermMapping[paymentId])"
                                        v-model="SnelStartV2Config.creditTermMapping[paymentId]"
                                        @change="forceRerender()"
                                        required/>
                            </b-form-group>
                        </div>
                        <div class="col-1 lowProfileRow">
                            <v-btn icon
                                   @click="forceRerender(), delete SnelStartV2Config.creditTermMapping[paymentId]">
                                <v-icon color="error">mdi-minus-circle</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <b-form-group label="Add new credit term for payment id mapping">
                        <div class="row">
                            <div class="col-10">
                                <b-form-input id="newCreditTermForPaymentId"
                                              placeholder="703b96f4b7ec4886909d22698b3e9a6e"
                                              class="form-control-sm"
                                              v-model="tempVars.newCreditTermIdField"/>
                            </div>
                            <div class="col-2">
                                <v-btn icon
                                       @click='forceRerender(), SnelStartV2Config.creditTermMapping[tempVars.newCreditTermIdField] = "", tempVars.newCreditTermIdField = ""'
                                       :disabled="!isNotNullAndUndefinedAndEmpty(tempVars.newCreditTermIdField)">
                                    <v-icon color="success">mdi-plus-circle</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </b-form-group>
                </b-form-group>


                <hr/>
                <h3>Customer group to sales template</h3>
                <hr/>

                <b-form-group>
                    <div class="row">
                        <p class="col-5">Shopware customer group ID</p>
                        <p class="col-5">Sales template Id</p>
                        <p class="col-1">Delete</p>
                    </div>
                    <div class="row"
                         v-for="(customerGroupId) in objectKeys(SnelStartV2Config.CustomerGroupToSalesOrderTemplate)"
                         :key="componentKey">
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input :value="customerGroupId" readonly/>
                            </b-form-group>
                        </div>
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input
                                        id="creditTerm"
                                        placeholder="2d1ebd27-7367-4921-9288-a992d9fb9131"
                                        :state="isNotNullAndUndefinedAndEmpty(SnelStartV2Config.CustomerGroupToSalesOrderTemplate[customerGroupId])"
                                        v-model="SnelStartV2Config.CustomerGroupToSalesOrderTemplate[customerGroupId]"
                                        @change="forceRerender()"
                                        required/>
                            </b-form-group>
                        </div>
                        <div class="col-1 lowProfileRow">
                            <v-btn icon
                                   @click="forceRerender(), delete SnelStartV2Config.CustomerGroupToSalesOrderTemplate[customerGroupId]">
                                <v-icon color="error">mdi-minus-circle</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <b-form-group label="Add customer group for sales order template">
                        <div class="row">
                            <div class="col-10">
                                <b-form-input id="newCustomerGroupSalesTemplateId"
                                              placeholder="d70a9a938fb9463fb96e27a46cf08a0f"
                                              class="form-control-sm"
                                              v-model="tempVars.newCustomerGroupIdField"/>
                            </div>
                            <div class="col-2">
                                <v-btn icon
                                       @click='forceRerender(), SnelStartV2Config.CustomerGroupToSalesOrderTemplate[tempVars.newCustomerGroupIdField] = "", tempVars.newCustomerGroupIdField = ""'
                                       :disabled="!isNotNullAndUndefinedAndEmpty(tempVars.newCustomerGroupIdField)">
                                    <v-icon color="success">mdi-plus-circle</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </b-form-group>
                </b-form-group>


                <hr/>
                <h3>Generic Customer for customer groups mapping</h3>
                <hr/>
                <b-form-group label="Generic B2C email for SnelStart.">
                    <b-form-input
                            id="SnelStartGenericEmailB2CId"
                            placeholder="genericB2C@email.com"
                            :state="isNotNullAndUndefinedAndEmpty(SnelStartV2Config.genericEmailB2C)"
                            v-model="SnelStartV2Config.genericEmailB2C"
                            required/>
                </b-form-group>
                <b-form-group>
                    <h5>All customers in B2C will be grouped in SnelStart in a generic b2c customer</h5>

                    <b-form-group label="B2C customer groups in Shopware. (groupId)">
                        <b-form-input
                                v-for="(group, index) in SnelStartV2Config.b2cCustomerGroups"
                                id="b2cGroup"
                                placeholder="d70a9a938fb9463fb96e27a46cf08a0f"
                                name="shopware6ToExactOnline1Config.customerGroups.b2c[]"
                                :state="isNotNullAndUndefinedAndEmpty(SnelStartV2Config.b2cCustomerGroups[index])"
                                v-model="SnelStartV2Config.b2cCustomerGroups[index]"
                                :value="group"
                                required/>
                    </b-form-group>
                    <v-btn icon @click='SnelStartV2Config.b2cCustomerGroups.push("")'>
                        <v-icon color="success">mdi-plus-circle</v-icon>
                    </v-btn>
                    <v-btn icon @click='SnelStartV2Config.b2cCustomerGroups.pop()'>
                        <v-icon color="error">mdi-minus-circle</v-icon>
                    </v-btn>
                </b-form-group>

                <hr/>
                <h3>Shipping country (ISO3) to SnelStart customer (ID)</h3>
                <hr/>

                <b-form-group>
                    <b-form-group label="Fall back for customer account from snelstart.">
                        <b-form-input
                                id="SnelStartCountryFallback"
                                placeholder="ad5d4597-ce5c-404a-bd5a-00145ffb8bc0"
                                :state="isNotNullAndUndefinedAndEmpty(SnelStartV2Config.countryToSnelStartCustomer.fallback)"
                                v-model="SnelStartV2Config.countryToSnelStartCustomer.fallback"
                                required/>
                    </b-form-group>
                    <b-form-group label="Fall back for eu customer account from snelstart.">
                        <b-form-input
                                id="SnelStartCountryEuFallback"
                                placeholder="ad5d4597-ce5c-404a-bd5a-00145ffb8bc0"
                                :state="isNotNullAndUndefinedAndEmpty(SnelStartV2Config.countryToSnelStartCustomer.EUfallback)"
                                v-model="SnelStartV2Config.countryToSnelStartCustomer.EUfallback"
                                required/>
                    </b-form-group>

                    <div class="row">
                        <p class="col-5">ISO3 country</p>
                        <p class="col-5">SnelStart customer id</p>
                        <p class="col-1">Delete</p>
                    </div>
                    <div class="row"
                         v-for="(country) in objectKeys(SnelStartV2Config.countryToSnelStartCustomer.list)"
                         :key="componentKey">
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input :value="country" readonly/>
                            </b-form-group>
                        </div>
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input
                                        id="SnelStartCustomer"
                                        placeholder="ad5d4597-ce5c-404a-bd5a-00145ffb8bc0"
                                        :state="isNotNullAndUndefinedAndEmpty(SnelStartV2Config.countryToSnelStartCustomer.list[country])"
                                        v-model="SnelStartV2Config.countryToSnelStartCustomer.list[country]"
                                        @change="forceRerender()"
                                        required/>
                            </b-form-group>
                        </div>
                        <div class="col-1 lowProfileRow">
                            <v-btn icon
                                   @click="forceRerender(), delete SnelStartV2Config.countryToSnelStartCustomer.list[country]">
                                <v-icon color="error">mdi-minus-circle</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <b-form-group label="Add new Country to mapping: ISO3 standard">
                        <div class="row">
                            <div class="col-10">
                                <b-form-input id="newCreditTermForPaymentId"
                                              placeholder="NLD"
                                              class="form-control-sm"
                                              v-model="tempVars.newCountryToSnelStartCustomer"/>
                            </div>
                            <div class="col-2">
                                <v-btn icon
                                       @click='forceRerender(), SnelStartV2Config.countryToSnelStartCustomer.list[tempVars.newCountryToSnelStartCustomer] = "", tempVars.newCountryToSnelStartCustomer = ""'
                                       :disabled="!isNotNullAndUndefinedAndEmpty(tempVars.newCountryToSnelStartCustomer)">
                                    <v-icon color="success">mdi-plus-circle</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </b-form-group>
                </b-form-group>


                <hr/>
            </b-form>
            <i>*Makes sure all the field are present, does not validate their value.</i>
        </v-app>
        <template slot="modal-footer">
            <b-button block
                      variant="secondary"
                      @click="forceRerender">
                Check required fields
                <v-icon dark>mdi-file-document-box-search-outline</v-icon>
                *
            </b-button>
            <v-divider vertical/>
            <b-button block
                      variant="primary"
                      @click="save">
                Save config
                <v-icon dark>mdi-content-save-outline</v-icon>
            </b-button>
        </template>
    </b-modal>
</template>
<script>
    import ProjectRepository from '../../../repositories/project.repository'

    export default {
        props: {
            projectConfig: {
                type: Object,
                default: () => {
                }
            },
            projectId: {
                type: Number,
                default: -1
            }
        },
        data() {
            return {
                componentKey: 0,
                tempVars: {
                    newShippingTaxIdField: null,
                    newTurnOverIdField: null,
                    newCreditTermIdField: null,
                    newCustomerGroupIdField: null,
                    newCountryToSnelStartCustomer: null,
                },
                SnelStartV2Config: {
                    ShippingCostCode: null,
                    ShippingCostCodeForTax: {},
                    TurnoverGroupMapping: {
                        ShippingTax: null,
                    },
                    CustomerGroupToSalesOrderTemplate: {},
                    creditTermMappingFallback: null,
                    creditTermMapping: {},
                    countryToSnelStartCustomer: {fallback: "", EUfallback: "", list: []},
                    genericEmailB2C: null,
                    b2cCustomerGroups: [],
                },
            }
        },
        methods: {
            save() {
                this.forceRerender();
                if (this.$refs.snel_start_v2_manager_modal_form.checkValidity()) {
                    this.projectConfig.SnelStartV2Config = this.SnelStartV2Config;
                    this.$emit('show-loading-pop-up', "Saving the project Config");
                    this.$bvModal.hide('snel_start_v2_manager_modal');
                    ProjectRepository.saveProjectConfig(this.projectConfig, this.projectId).then(res => {
                        this.$emit('reset-loading-pop-up');
                        this.$emit('saved-project-config');
                        this.$bvToast.toast('Successfully saved the project config', {
                            title: `Config save successful.`,
                            variant: 'success',
                            solid: true
                        });
                    }).catch(error => {
                        this.$bvModal.show('snel_start_v2_manager_modal');
                        console.error(error);
                        this.$bvToast.toast('Looks like something went wrong on the server while saving the project config.', {
                            title: `Config save error.`,
                            variant: 'danger',
                            solid: true
                        });
                    });
                }
            },
            isNotNullAndUndefinedAndEmpty(value) {
                return (value !== undefined && value !== null && value !== "");
            },
            objectKeys(val) {
                return Object.keys(val);
            },
            forceRerender() {
                this.componentKey++;
            }
        },
        watch: {
            projectConfig() {
                if (this.projectConfig.SnelStartV2Config !== undefined) {
                    this.SnelStartV2Config = this.projectConfig.SnelStartV2Config;
                }
            }
        }
    }
</script>

